import React, { useEffect, useState } from 'react';
import ReusableDiv from 'src/helper/ReusableDiv';
import { useUserStore } from "../../../hooks/admin/user";
import UserSearchAcctList from '../userManagement/UserSearchAcctList';
import UserSearchAcct from '../userManagement/UserSearchAcct';
import useReduxState from 'src/hooks/useReduxState';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import { useObjCommonFilterStore } from '../../../hooks/objCommonFilter';
import { Tooltip } from 'src/component/Global/Tooltip';
import System from 'src/helper/system';
import Admin from "@system/config/admin";
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from "../../../hooks/domAttachToSystem";
import ShowAlert from 'src/component/Global/ShowAlert';

const SponsorUserAcct = (props) => {
  const { data, SetStatus } = props;

  const [{ selectedAccounts }, { }, {
    update_user_acct_sponsorship,
    set_user_search_acct_popup_status,
    set_selected_accounts
  }] = useUserStore();
  const [{ }, { }, { clear_all_filter }] = useObjCommonFilterStore();
  const [disableSponsorBtn, setDisableSponsorBtn] = useState(true);
  const [sponsorBtnTooltip, setSponsorBtnTooltip] = useState('Please select accounts to sponsor');
  const [, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
  const [isSponsorRoleSelect, setIsSponsorRoleSelect] = useReduxState(false, 'setIsSponsorRoleSelect');
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

  useEffect(() => {
    set_user_search_acct_popup_status(true)
  }, []);

  const onHide = () => {
    clear_all_filter()
    set_user_search_acct_popup_status(false)
    SetStatus(false)
    set_selected_accounts([]);
    if (isSponsorRoleSelect) {
      setIsSponsorRoleSelect(false);
    }

  };

  useEffect(() => {
    setSponsorBtnTooltip('')
    setDisableSponsorBtn(false);
    if (!selectedAccounts || selectedAccounts.length === 0) {
      setDisableSponsorBtn(true);
      return;
    }
    for (let i = 0; i < selectedAccounts.length; i++) {
      if (!(selectedAccounts[i].Role && selectedAccounts[i].Role.length > 0)) {
        setSponsorBtnTooltip('Please select a role for the accounts you want to sponsor.');
        setDisableSponsorBtn(true);
        return
      }
    }
  }, [selectedAccounts])
  const onSubmit = async () => {
    const accountList = selectedAccounts.map(v => {
      return {
        accountNumber: v.AccountNumber,
        speedboat: System.avUserInfoData.speedBoatAbbr,
        salesOrg: v.SalesOrg,
        roleId: v.Role,
        userId: data.userId
      }
    })
    const res = await update_user_acct_sponsorship({ accountList });
    if (res?.payload?.Message) {
      system_alert_indicator({
          name: "accessDenied",
          message: data?.payload?.Message,
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false
      });
  }
    if (res.isSuccessFull) {
      system_alert_indicator({
        name: "adminconsole",
        message: res.data || 'Account(s) have been successfully sponsored.',
        type: "success",
        isDisplay: true,
      });

      if (data.userType === Constants.siteUser.WEB) {
        const newUrl = Admin.getUserDetailURL() + '?uid=' + data.userId + '&userType=' + Constants.siteUser.CORE;
        window.location.href = newUrl;
      }
      setRefreshGrid(true);
      onHide();
    } else {

      system_alert_indicator({
        name: "sponserUserAcctError",
        message: res.message || 'Something went wrong',
        type: "danger",
        isDisplay: false,
        isDisplayIcon: true
      });

    }
  };

  return (
    <>
      {/* <Modal show={userSearchAcctPopupStatus} onHide={() => {
        onHide()
      }}> */}
      <div className="avnet-modal modal-1250" id='sponsoraccount'>
        <div className="avnet-modal-inner">
          <button type="button" className="close py-3" data-dismiss="modal"
            onClick={onHide}>×
          </button>
          {ReusableDiv.PopupTitle("Sponsor to an Account")}
          <div className="modal-body sponsor-account-popup">
            <div className='alert-message'>
              <ShowAlert onlyShowMessage={['sponserUserAcctError']} />

            </div>
            <UserSearchAcct />
            <ObjCommonFilterSelection />
            <UserSearchAcctList userData={data} />
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button type="button" className="bs5 btn btn-secondary"
              onClick={onHide}>Cancel
            </button>

            {sponsorBtnTooltip ? <Tooltip
              position={'top center'}
              opener={() => (<div style={{
                marginLeft: '15px'
              }}>
                <button type="button" disabled={disableSponsorBtn} className="bs5 btn btn-primary"
                  onClick={onSubmit}> Sponsor
                </button>
              </div>)}
              content={() => sponsorBtnTooltip}
            /> : <button type="button" disabled={disableSponsorBtn} className="bs5 btn btn-primary"
              onClick={onSubmit}> Sponsor</button>}
          </div>
        </div>
      </div>
      {/* </Modal> */}

    </>
  )
}

export default SponsorUserAcct;